import { z } from 'zod'
import { parseKwacha } from '@/lib/money'

export function amountToNgwee(text: string): number | null {
  const n = parseKwacha(text)
  return n !== null && n > 0 ? n : null
}

const DATE = /^\d{4}-\d{2}-\d{2}$/

export const expenseFormSchema = z.object({
  incurredOn: z.string().regex(DATE, 'Pick the date of the expense'),
  payee: z.string().trim().min(2, 'Who was paid?').max(80, 'Use a shorter name'),
  description: z.string().trim().min(2, 'Say what it was for').max(120, 'Use a shorter description'),
  amount: z.string().refine((v) => amountToNgwee(v) !== null, 'Enter an amount like 500 or 500.00'),
  budgetLineId: z.string(), // '' means not in the budget
  categoryId: z.string().min(1, 'Pick a category'),
  paidFrom: z.enum(['department_cash', 'central_treasury']),
  method: z.enum(['cash', 'mobile_money', 'bank_transfer']),
  receiptNo: z.string().trim().max(60, 'Use a shorter receipt number'),
  alreadyPaid: z.boolean(),
  paidOn: z.string(),
})

export const paidDateSchema = z.string().regex(DATE, 'Pick the date it was paid')
export const reasonSchema = z.object({
  reason: z.string().trim().min(3, 'Give a reason (at least a few words)').max(300, 'Use a shorter reason'),
})
